import { HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import * as _ from 'lodash';
import { AuthService } from './auth.api';

@Injectable({
    providedIn: 'root'
})
export class DefaultHttpHeaderOptions {

  protected environment: any
  private _baseUrl: string

    constructor(@Inject('AppEnvironment') environmentConfig,
    ) {
      this.environment = environmentConfig;
      this._baseUrl = this.environment.apiBase + '/' + (this.environment.apiVersion ? this.environment.apiVersion + '/' : '');
    }

    get baseUrl() {
      return this._baseUrl;
    }

    baseRequestOptions(): object {
      const userData = JSON.parse(localStorage.getItem('userData'+this.environment.role));
      const bearer_token: string = _.get(userData, '_token', null);

      return {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Headers': '*',
          'Accept': 'application/json',
          'Access-Control-Expose-Headers': '*',
          'Authorization': `Bearer ${bearer_token}`,
          'x-api-key': _.get(this.environment, 'xApiToken', ""),
        }),
        withCredentials: true,
        observe: 'response',
      }
    }
}

